/* SPARSHA Zodiac — theme scripts (no dependencies) */
(function () {
  'use strict';

  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  // Sign start dates (month, day). A date before the start belongs to the previous sign.
  var SIGNS = [
    { name: 'Capricorn',   glyph: '♑', from: [12, 22] },
    { name: 'Aquarius',    glyph: '♒', from: [1, 20] },
    { name: 'Pisces',      glyph: '♓', from: [2, 19] },
    { name: 'Aries',       glyph: '♈', from: [3, 21] },
    { name: 'Taurus',      glyph: '♉', from: [4, 20] },
    { name: 'Gemini',      glyph: '♊', from: [5, 21] },
    { name: 'Cancer',      glyph: '♋', from: [6, 21] },
    { name: 'Leo',         glyph: '♌', from: [7, 23] },
    { name: 'Virgo',       glyph: '♍', from: [8, 23] },
    { name: 'Libra',       glyph: '♎', from: [9, 23] },
    { name: 'Scorpio',     glyph: '♏', from: [10, 23] },
    { name: 'Sagittarius', glyph: '♐', from: [11, 22] }
  ];

  function signFor(month, day) {
    var key = month * 100 + day;
    var found = SIGNS[0]; // Capricorn wraps the year end
    for (var i = 1; i < SIGNS.length; i++) {
      var s = SIGNS[i];
      if (key >= s.from[0] * 100 + s.from[1]) found = s;
    }
    if (key >= 1222) found = SIGNS[0];
    return found;
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function zodiacData() {
    var el = $('[data-zodiac-json]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function currentMonth() {
    var cal = $('[data-zodiac-calendar]');
    var forced = cal && cal.getAttribute('data-feature-month');
    if (forced && forced !== 'auto') return parseInt(forced, 10);
    return new Date().getMonth() + 1;
  }

  /* ---------- Zodiac calendar ---------- */
  function initCalendar() {
    var root = $('[data-zodiac-calendar]');
    if (!root) return;
    var tabs = $$('.zc-card', root);
    var panels = $$('.zc-spotlight', root);
    var now = currentMonth();

    function select(month, focus) {
      tabs.forEach(function (t) {
        var on = parseInt(t.dataset.month, 10) === month;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
        if (on) {
          var grid = t.closest('.zc-grid');
          if (grid && grid.scrollWidth > grid.clientWidth) {
            grid.scrollTo({ left: t.parentElement.offsetLeft - 16, behavior: 'smooth' });
          }
        }
      });
      panels.forEach(function (p) { p.hidden = parseInt(p.dataset.month, 10) !== month; });
    }

    tabs.forEach(function (t) {
      t.classList.toggle('is-current', parseInt(t.dataset.month, 10) === now);
      t.addEventListener('click', function () { select(parseInt(t.dataset.month, 10)); });
      t.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(t);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(parseInt(next.dataset.month, 10), true);
        }
      });
    });
    panels.forEach(function (p) { p.classList.toggle('is-current', parseInt(p.dataset.month, 10) === now); });

    var hasNow = tabs.some(function (t) { return parseInt(t.dataset.month, 10) === now; });
    if (hasNow) select(now);
    else if (tabs[0]) select(parseInt(tabs[0].dataset.month, 10));

    document.addEventListener('sparsha:select-month', function (e) { select(e.detail.month); });
  }

  /* ---------- Hero wheel + "now in season" ---------- */
  function initHero() {
    var now = currentMonth();
    var data = zodiacData();
    var entry = data.filter(function (d) { return d.month === now; })[0];

    $$('.zodiac-wheel__month').forEach(function (a) {
      var m = parseInt(a.dataset.month, 10);
      a.classList.toggle('is-current', m === now);
      a.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('sparsha:select-month', { detail: { month: m } }));
      });
    });

    if (!entry) return;
    var line = $('[data-hero-now]');
    if (line) {
      $('[data-now-title]', line).textContent = entry.title;
      $('[data-now-stone]', line).textContent = entry.stones;
      line.hidden = false;
    }
    $$('[data-now-link]').forEach(function (a) { a.href = entry.url; });
  }

  /* ---------- Birthstone finder ---------- */
  function initFinder() {
    var root = $('[data-finder]');
    if (!root) return;
    var form = $('[data-finder-form]', root);
    var result = $('[data-finder-result]', root);
    var data = zodiacData();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var month = parseInt(form.month.value, 10);
      var day = Math.min(31, Math.max(1, parseInt(form.day.value, 10) || 1));
      var sign = signFor(month, day);
      var entry = data.filter(function (d) { return d.month === month; })[0];

      $('[data-finder-placeholder]', root).hidden = true;
      $('[data-finder-art]', root).hidden = false;
      $$('[data-art-month]', root).forEach(function (el) { el.hidden = parseInt(el.dataset.artMonth, 10) !== month; });
      $('[data-finder-body]', root).hidden = false;

      $('[data-finder-sign]', root).textContent = sign.glyph + '︎ ' + sign.name + ' · ' + MONTHS[month - 1] + ' ' + day;
      if (entry) {
        result.style.setProperty('--gem', entry.gem);
        result.style.setProperty('--gem-2', entry.gem2);
        $('[data-finder-title]', root).textContent = entry.stones;
        $('[data-finder-text]', root).textContent =
          'You belong to ' + entry.title + ' — ruled by ' + entry.planets + ', for ' + entry.intention.toLowerCase() + '.';
        var link = $('[data-finder-link]', root);
        link.href = entry.url;
        link.textContent = 'Shop ' + entry.title.replace(/^The /, '').replace(/ Collection$/, '');
      } else {
        $('[data-finder-title]', root).textContent = MONTHS[month - 1];
        $('[data-finder-text]', root).textContent = 'Explore every birthstone bracelet.';
      }
    });
  }

  /* ---------- Cart helpers ---------- */
  function toast(msg) {
    var t = $('#CartToast');
    if (!t) return;
    $('.toast__msg', t).textContent = msg;
    t.hidden = false;
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.hidden = true; }, 4000);
  }
  function bumpCount(qty) {
    $$('[data-cart-count]').forEach(function (el) {
      var n = (parseInt(el.textContent, 10) || 0) + qty;
      el.textContent = n;
      el.dataset.count = n;
    });
  }
  function addToCart(body) {
    return fetch(window.SPARSHA.routes.cart_add, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: body
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw new Error(json.description || json.message || 'Could not add to bag');
        return json;
      });
    });
  }

  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var fd = new FormData();
      fd.append('id', btn.dataset.quickAdd);
      fd.append('quantity', '1');
      btn.disabled = true;
      addToCart(fd).then(function () {
        bumpCount(1);
        toast(btn.dataset.title + ' added to your bag');
      }).catch(function (err) { toast(err.message); })
        .finally(function () { btn.disabled = false; });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      var input = b.parentElement.querySelector('input');
      var min = parseInt(input.min || '0', 10);
      input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    var cartForm = $('[data-cart-form]');
    if (cartForm) {
      var timer;
      cartForm.addEventListener('change', function (e) {
        if (!e.target.matches('[data-cart-qty]')) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          var input = document.createElement('input');
          input.type = 'hidden'; input.name = 'update'; input.value = '1';
          cartForm.appendChild(input);
          cartForm.submit();
        }, 500);
      });
    }
  }

  /* ---------- Product form ---------- */
  function initProduct() {
    var root = $('[data-product-form-root]');
    if (!root) return;
    var json = $('[data-product-json]', root);
    var form = $('[data-product-form]', root) || $('form[action*="/cart/add"]', root);
    if (!json || !form) return;
    var variants = JSON.parse(json.textContent).variants;
    var idInput = $('[data-variant-id]', form);
    var gallery = $('.product__gallery', root);
    var LEAD_SIZES = '(min-width: 900px) 55vw, 100vw';
    var THUMB_SIZES = '(min-width: 900px) 27vw, 50vw';

    // Show the chosen color's photo as the main image.
    function showMedia(mediaId) {
      if (!gallery || !mediaId) return;
      var target = $('[data-media-id="' + mediaId + '"]', gallery);
      if (!target) return;
      var lead = gallery.firstElementChild;
      if (lead !== target) {
        $$('.product__media', gallery).forEach(function (m) {
          m.removeAttribute('data-lead');
          var img = $('img', m);
          if (img) img.setAttribute('sizes', THUMB_SIZES);
        });
        gallery.insertBefore(target, lead);
      }
      target.setAttribute('data-lead', '');
      var img = $('img', target);
      if (img) { img.setAttribute('sizes', LEAD_SIZES); img.loading = 'eager'; }
      if (gallery.scrollWidth > gallery.clientWidth) gallery.scrollTo({ left: 0, behavior: 'smooth' });
    }
    var priceEl = $('[data-price]', root);
    var addBtn = $('[data-add-button]', form);

    function selected() {
      var opts = [];
      $$('.option-group', form).forEach(function (fs) {
        var c = $('input:checked', fs);
        opts.push(c ? c.value : null);
      });
      return opts;
    }
    function update() {
      var opts = selected();
      var v = variants.filter(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      })[0];
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      showMedia(v.media);
      priceEl.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    form.addEventListener('change', function (e) { if (e.target.dataset.optionIndex !== undefined) update(); });
    // On load (e.g. a link with ?variant=), lead with that color's photo.
    var start = variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0];
    if (start) showMedia(start.media);

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      addBtn.disabled = true;
      var fd = new FormData(form);
      var qty = parseInt(fd.get('quantity'), 10) || 1;
      if (fd.get('properties[Engraving]') === '') fd.delete('properties[Engraving]');
      addToCart(fd).then(function (item) {
        bumpCount(qty);
        toast((item.product_title || 'Item') + ' added to your bag');
      }).catch(function (err) { toast(err.message); })
        .finally(function () { addBtn.disabled = false; });
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations() {
    var el = $('[data-recommendations]');
    if (!el) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var inner = tmp.querySelector('.shopify-section');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }

  /* ---------- Search modal + sorting ---------- */
  function initMisc() {
    var modal = $('[data-search-modal]');
    $$('[data-open-search]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (modal && modal.showModal) { modal.showModal(); $('input[type=search]', modal).focus(); }
        else window.location.href = '/search';
      });
    });
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });

    var sort = $('[data-sort-by]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function init() {
    initCalendar(); initHero(); initFinder(); initQuickAdd(); initQty(); initProduct(); initRecommendations(); initMisc();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-run when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function () { initCalendar(); initHero(); initFinder(); });
})();
